export function connectSSE(vm,pre) {
    const baseUrl = process.env.VUE_APP_BASE_URL || '';
    const authorization = localStorage.getItem(`${window.location.hostname}_token`);
    const userId = localStorage.getItem(`${window.location.hostname}_mid`);
    const url = `${baseUrl}sse/connect?userId=${userId}&Authorization=${authorization}&pre=${pre}`;
    const sseConnection = new EventSource(url);
    return sseConnection;
}